export default function ($scope, $timeout, $mdDialog, $filter, Restangular, FlashService, progression, licences, users, invoices) {

    $scope.selected = [];

    $scope.invoices = [];
    $scope.licences = licences;
    $scope.users = users;
    $scope.is_company = HasRole('company');
    $scope.current = GetData().currentUser.id;

    $scope.user_reassign = null;
    $scope.licence = null;
    $scope.toggleInvoiceLicence = null;
    $scope.licenceInvoices = null;

    $scope.pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    invoices.forEach(function (v, i) {

        if (!v.purchase) return;

        let date = ParseDate(v.created);
        v.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(v.purchase.id, 4);

        if (v.payment) {
        } else {
            $scope.invoices.push(v);
        }
    });


    licences.forEach(function (v, i){
        if((v.purchase && !v.purchase.paypal_status) || (v.purchase && ['recurring_payment_skipped', 'mp_cancel','recurring_payment_failed'].indexOf(v.purchase.paypal_status) >= 0)){
            v.purchase.paypal_status = 'recurring_payment_default';
        }
    });


    $scope.removeIdentifier = function ($event, licence) {

        progression.start();

        var confirm = $mdDialog.confirm()
            .title($filter('translate')('REMOVE_YOUR_LICENCE_LINK'))
            .htmlContent($filter('translate')('REMOVE_YOUR_LICENCE_LINK_TEXT'))
            .ariaLabel($filter('translate')('LUCKY_DAY'))
            .targetEvent($event)
            .ok($filter('translate')('REMOVE!'))
            .cancel($filter('translate')('CANCEL'));

        $mdDialog.show(confirm).then(function () {

            progression.done();

            return Restangular
                .one("licence", licence.id)
                .one("identifier")
                .remove()
                .then(function (data) {
                    FlashService.Success($filter('translate')("SUCCESS_REMOVE_LICENCE"));

                    licence.identifier = "";
                });


        });

    };

    $scope.toggle_invoices = function ($event, licence) {
        if ($scope.toggleInvoiceLicence == licence.licence) {
            $scope.toggleInvoiceLicence = null;
            $scope.licenceInvoices = null;
        } else {
            if (typeof licence.purchase != 'undefined') {
                $scope.toggleInvoiceLicence = licence.licence;
                $scope.licenceInvoices = $scope.invoices.filter(function(x) {
                    return x.purchase.id == licence.purchase.id;
                })
            }
        }
    }

    $scope.viewInvoice = function ($event, invoice) {
        return Restangular
            .one("invoice", invoice.id)
            .one("pdf")
            .withHttpConfig({responseType: 'blob'})
            .get()
            .then(data => {
                data = data.data ? data.data : data;

                let fileName = 'BrainVt-' + invoice.numeration + '.pdf';
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                let file = new Blob([data], {type: 'application/pdf'});
                let fileURL = (window.URL || window.webkitURL).createObjectURL(file);

                //Open
                //window.open(fileURL);

                // Download
                a.href = fileURL;
                a.download = fileName;
                a.click();
                (window.URL || window.webkitURL).revokeObjectURL(data);

            });
    }

    $scope.cancel_subscription = function ($event, licence) {
        progression.start();

        var confirm = $mdDialog.confirm()
            .title($filter('translate')('CANCEL_YOUT_SUBSCRIPTION'))
            .htmlContent($filter('translate')('CANCEL_YOUT_SUBSCRIPTION_TEXT'))
            .ariaLabel($filter('translate')('LUCKY_DAY'))
            .targetEvent($event)
            .ok($filter('translate')('OK!'))
            .cancel($filter('translate')('CANCEL'));

        $mdDialog.show(confirm).then(function () {


            progression.done()

            return Restangular
                .one("purchase", licence.purchase.id)
                .one("cancel")
                .remove()
                .then(function (data) {
                    FlashService.Success($filter('translate')("SUCCESS_CANCEL_SUBSCRIPTION"));

                    $scope.licences.map(function(l){
                        if(l.id == licence.id){
                            l.purchase.paypal_status = 'recurring_payment_profile_cancel';
                        }

                        return l;
                    })
                });
        });

    }

    $scope.suspend_subscription = function ($event, licence) {
        progression.start();

        var confirm = $mdDialog.confirm()
            .title($filter('translate')('SUSPEND_YOUT_SUBSCRIPTION'))
            .htmlContent($filter('translate')('SUSPEND_YOUT_SUBSCRIPTION_TEXT'))
            .ariaLabel($filter('translate')('LUCKY_DAY'))
            .targetEvent($event)
            .ok($filter('translate')('OK!'))
            .cancel($filter('translate')('CANCEL'));

        $mdDialog.show(confirm).then(function () {


            progression.done()

            return Restangular
                .one("purchase", licence.purchase.id)
                .one("suspend")
                .remove()
                .then(function (data) {
                    FlashService.Success($filter('translate')("SUCCESS_SUSPEND_SUBSCRIPTION"));

                    $scope.licences.map(function(l){
                        if(l.id == licence.id){
                            l.purchase.paypal_status = 'recurring_payment_suspended';
                        }

                        return l;
                    })
                });
        });

    }
};


/** WEBPACK FOOTER **
 ** ./js/theme/licences/controller.js
 **/